angular.module('eatself')
.filter('choice', function() {
  return function(input, mode) {
  	if (input != -1) {
  		return input;
  	}
  	return mode == 'min' ? 0 : 'Illimité';
  };
})
